import Swiper from 'swiper';
import { breakpoints } from '../conf';

export default () => {
  const el = document.querySelector('[data-twin-col-swiper]');

  const options = {
    autoHeight: true,
    updateOnImagesReady: true,
    preloadImages: true,
    loop: true,
    navigation: {
      nextEl: '[data-twin-col-swiper-next]',
      prevEl: '[data-twin-col-swiper-prev]'
    },
    watchOverflow: true
  };


  if(el) {
    const slideCount = el.dataset.twinColSwiperSlides;
    console.log('twin col');

    if (slideCount && parseInt(slideCount) && parseInt(slideCount) < 2) {
      options.loop = false;
    }

    var mySwiper = new Swiper('[data-twin-col-swiper]', options);
  }
};